import { CommApiInstance } from "Utils/CommApiInstance";


const MbpAthnRsltVrfRqstApi = async (
    kmcApiTknrslt:string        ,
    kmcApiCertNumrslt:string
) => {
    return await CommApiInstance.post(`athn/idnt_mthd/mbp/resp_tkn_vrf`,{
        apiBody: {
            apiTkn:kmcApiTknrslt,
            certNum:kmcApiCertNumrslt
        } 
    })
    .then((Resp) => Resp.data);
}

export default MbpAthnRsltVrfRqstApi;